/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CodeQualityData } from './CodeQualityData';
const CodeQualityExtraParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('code_quality')],
    ['data', CodeQualityData],
]);
export class CodeQualityExtra extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CodeQualityExtraParser.decode(input).map(res => new CodeQualityExtra(res));
    }
    static unsafeDecode(input) {
        return CodeQualityExtra.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodeQualityExtraParser.encode(data);
    }
    static schema() {
        return CodeQualityExtraParser.schema();
    }
}
